"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFloatingLinkEscape = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateLink = require("@udecode/plate-link");
var useFloatingLinkEscape = function useFloatingLinkEscape() {
  var editor = (0, _plateCommon.useEditorRef)();
  var open = (0, _plateLink.useFloatingLinkSelectors)().isOpen(editor.id);
  (0, _plateCommon.useHotkeys)('escape', function (e) {
    if (!_plateLink.floatingLinkSelectors.mode()) return;
    e.preventDefault();
    if (_plateLink.floatingLinkSelectors.mode() === 'edit' && _plateLink.floatingLinkSelectors.isEditing()) {
      _plateLink.floatingLinkActions.show('edit', editor.id);
      (0, _plateCommon.focusEditor)(editor, editor.selection);
      return;
    }
    if (_plateLink.floatingLinkSelectors.mode() === 'insert') {
      (0, _plateCommon.focusEditor)(editor, editor.selection);
    }
    _plateLink.floatingLinkActions.hide();
  }, {
    enableOnContentEditable: true,
    enableOnFormTags: ['INPUT'],
    enabled: open
  }, []);
};
exports.useFloatingLinkEscape = useFloatingLinkEscape;